export enum CorePageEndPoints {
    GET_NOTIFICATIONS = 'GetNotifications',
    GET_ALL_NOTIFICATIONS = 'GetAllNotifications',
    GET_USER_SETTINGS = 'GetTextData/UserProfile'
}

export enum CorePageQueryKey {
    GET_NOTIFICATIONS = 'GET_NOTIFICATIONS',
    GET_ALL_NOTIFICATIONS = 'GET_ALL_NOTIFICATIONS',
    GET_USER_SETTINGS = 'GET_USER_SETTINGS'
}
